import React from 'react';
import styles from './CookieBanner.module.scss';
import {handleCookieConsent} from "../../../../utils/cookieUtils";

interface CookieBannerProps {
  onConsent: () => void;
  onReject: () => void;
}

function CookieBanner({ onConsent, onReject }: CookieBannerProps) {
  const handleAcceptCookies = () => {
    handleCookieConsent(true);
    onConsent();
  };

  const handleRejectCookies = () => {
    handleCookieConsent(false);
    onReject();
  };
  return (
    <div id="cookie-banner" className={styles.cookieBanner}>
      <div className={styles.cookieText}>
        <p>
          We use cookies to analyze web traffic, improve our website, enhance user experience, and facilitate secure user authentication.
          By continuing to use MOOD, you agree to our use of these essential cookies. For more information, please see our
          <a
            href="https://www.dhigroup.com/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
        </p>
      </div>
      <div className={styles.buttonContainer}>
        <button className={styles.cookieAccept} onClick={handleAcceptCookies}>
          {/* <div>icon</div> */}
          <div>Accept Cookies</div>
        </button>
        <button className={styles.cookieReject} onClick={handleRejectCookies}>
          Reject
        </button>
      </div>
    </div>
  );
}

export default CookieBanner;
